var year = document.getElementById('release').innerText.match(/ built on (20\d\d)-/)[1];

export default [
    {
        name: 'Andxor web2sign',
        url: 'https://www.andxor.it/',
        author: '© 2012-' + year + ' Andxor soluzioni informatiche'
    }, {
        name: 'Leaflet',
        url: 'http://leafletjs.com/',
        author: [
            '© 2010-2017 Vladimir Agafonkin',
            '© 2010-2011 CloudMade'
        ],
        license: 'BSD-2-Clause',
        licenseUrl: 'https://github.com/Leaflet/Leaflet/blob/master/LICENSE'
    }, {
        name: 'ExpiringMap',
        url: 'https://github.com/jhalterman/expiringmap',
        author: '© 2009-2016 Jonathan Halterman',
        license: 'Apache 2.0',
        licenseUrl: 'https://github.com/jhalterman/expiringmap/blob/master/LICENSE.txt'
    }, {
        name: 'Bouncy Castle Crypto APIs',
        url: 'https://www.bouncycastle.org/java.html',
        author: '© 2000-' + year + ' The Legion of the Bouncy Castle Inc.',
        license: 'MIT',
        licenseUrl: 'https://www.bouncycastle.org/license.html'
    }, {
        name: 'ICEpdf',
        url: 'http://www.icesoft.org/java/projects/ICEpdf/overview.jsf',
        author: '© 2006-2012 ICEsoft Technologies Inc.',
        license: 'Apache 2.0',
        licenseUrl: 'http://www.icesoft.org/java/community/license-faq.jsf#os-licenses'
    }, {
        name: 'OpenPDF',
        url: 'https://github.com/LibrePDF/OpenPDF',
        author: [
            '© 1999-2009 Bruno Lowagie et al.',
            '© 2016-' + year + ' LibrePDF'
        ],
        license: 'MPL 2.0 / LGPL 2.1',
        licenseUrl: 'https://github.com/LibrePDF/OpenPDF/blob/master/License.md'
    }, {
        name: 'Logback',
        url: 'https://logback.qos.ch/',
        author: '© 2018 QOS.ch',
        license: 'EPL 1.0 / LGPL 2.1',
        licenseUrl: 'https://logback.qos.ch/license.html'
    }, {
        name: 'SLF4J',
        url: 'https://www.slf4j.org/',
        author: '© 2004-2017 QOS.ch',
        license: 'MIT',
        licenseUrl: 'https://www.slf4j.org/license.html'
    }, {
        name: 'webpack',
        url: 'https://webpack.js.org/',
        author: '© JS Foundation and other contributors',
        license: 'MIT',
        licenseUrl: 'https://github.com/webpack/webpack/blob/master/LICENSE'
    }, {
        name: 'jQuery',
        url: 'https://jquery.org/',
        author: '© 2018 The jQuery Foundation',
        license: 'MIT',
        licenseUrl: 'https://jquery.org/license/'
    }, {
        name: 'jQuery UI',
        url: 'https://jqueryui.com/',
        author: '© 2018 The jQuery Foundation',
        license: 'MIT',
        licenseUrl: 'https://jquery.org/license/'
    }, {
        name: 'Less',
        url: 'http://lesscss.org/',
        author: '© 2009-2017 Alexis Sellier & The Core Less Team',
        license: 'Apache 2.0',
        licenseUrl: 'https://github.com/less/less.js/blob/master/LICENSE'
    }
];
